module.exports = __webpack_public_path__ + "img/eth.2f9c1da3.svg";